import { IOrganizationProductListItem } from './../../../../services/organization.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ChangeDetectionStrategy, Component, Inject, Input } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { LogService } from 'src/app/services/log.service';
import { OrganizationService } from 'src/app/services/organization.service';
import { AppFieldValidators } from 'src/app/utilities/validators';
import {
  COEFF_EXP_DEFAULT,
  COEFF_EXP_RANGE_MESSAGE,
  coeffExpOrDefault,
  coeffExpValidator,
} from 'src/app/utilities/coefficient-expansion';

@Component({
  selector: 'app-product-form',
  templateUrl: './product-form.component.html',
  styleUrls: ['./product-form.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductFormComponent {
  @Input()
  productForm: any;
  formGroup: UntypedFormGroup = this._fb.group({});
  Validators = AppFieldValidators;

  readonly coeffExpPlaceholder = String(COEFF_EXP_DEFAULT);
  readonly coeffExpValidators = [coeffExpValidator(() => this.productForm?.coeffExp)];

  get coeffExpErrorText(): string | null {
    return this.formGroup.get('coeffExp')?.hasError('coeffExpRange') ? COEFF_EXP_RANGE_MESSAGE : null;
  }

  @Input() orgId: number;

  get isSubmitDisabled() : boolean {
    return !this.formGroup.dirty || this.formGroup.invalid
  };


  get formTitle() {
    return this.isProductUpdate()
      ? 'OrganizationDetails.Products.UpdateProduct'
      : 'OrganizationDetails.Products.AddProduct';
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ProductFormVM,
    private _mdr: MatDialogRef<ProductFormComponent>,
    private _fb: UntypedFormBuilder,
    private _logger: LogService,
    private _os: OrganizationService,
  ) {
    this.initializeForm(data);
  }

  onCancelClick() {
    this._mdr.close();
  }

  onSubmit() {
    this.saveAndCloseForm();
  }

  private initializeForm(data: ProductFormVM) {
    this._logger.log('ProductFormComponent:initializeForm', data);
    this.orgId = data.orgId;
    this.productForm = this.data.product;
  }

  private isProductUpdate() {
    return this.productForm?.productId > 0;
  }

  private saveAndCloseForm() {
    if (this.formGroup.invalid) return false;
    const product = { ...this.formGroup.value, coeffExp: coeffExpOrDefault(this.formGroup.value.coeffExp) };
    this._os.saveProduct(this.orgId, product).subscribe({
      next: (product) => {
        this._logger.log('ProductFormComponent:saveForm:response', product);
        this._mdr.close(product);
      },
    });
  }
}

export interface ProductFormVM {
  orgId: number;
  product: IOrganizationProductListItem;
};
